import type { ReactNode } from 'react';
import { useIsAssistantAvailable } from '@/hooks/useIsAssistantAvailable';
import { AssistantAutomaticBrief } from './AssistantAutomaticBrief';
import { AssistantLiveRegion } from './AssistantLiveRegion';
import { AssistantPanelProvider } from './AssistantPanelProvider';
import { useAssistantShortcut } from './useAssistantShortcut';
import { AssistantUiProvider } from './uiActions/AssistantUiProvider';
import { SpotlightOverlay } from './uiActions/SpotlightOverlay';

function AssistantShortcut() {
  useAssistantShortcut(useIsAssistantAvailable());
  return null;
}

function AssistantAutomaticBriefWhenAvailable() {
  return useIsAssistantAvailable() ? <AssistantAutomaticBrief /> : null;
}

export function AssistantProviders({ children }: { children: ReactNode }) {
  return (
    <AssistantUiProvider>
      <AssistantPanelProvider>
        <AssistantShortcut />
        <AssistantAutomaticBriefWhenAvailable />
        {children}
        <SpotlightOverlay />
        <AssistantLiveRegion />
      </AssistantPanelProvider>
    </AssistantUiProvider>
  );
}
